import {
    CHALLENGES_REQUEST,
    CHALLENGES_SUCCESS,
    CHALLENGES_ERROR,

    CHALLENGES_LEADERBOARD_REQUEST,
    CHALLENGES_LEADERBOARD_SUCCESS,
    CHALLENGES_LEADERBOARD_ERROR,

    CHALLENGES_NEXT_CHALLENGE_INFO_SUCCESS,

    CHALLENGES_PROMO_SHOW,
    CHALLENGES_PROMO_HIDE,
} from 'state/actions/challenges'

const initialState = {
    data: {},
    meta: {},
    discipline: {},
    nextChallenge: {
        start_datetime: undefined,
        end_datetime: undefined,
    },
    errorMessage: null,
    loading: false,
    promoOpened: false,
}

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    case CHALLENGES_REQUEST: {
        return {
            ...state,
            loading: action.payload.spinner,
            errorMessage: null,
            discipline: {},
        }
    }
    case CHALLENGES_SUCCESS: {
        return {
            ...state,
            loading: false,
            data: action.payload.data,
            meta: action.payload.meta,
        }
    }
    case CHALLENGES_ERROR: {
        return {
            ...state,
            loading: false,
            errorMessage: action.payload.errorMessage,
        }
    }
    case CHALLENGES_LEADERBOARD_REQUEST: {
        return {
            ...state,
            loading: action.payload.spinner,
            errorMessage: null,
        }
    }
    case CHALLENGES_LEADERBOARD_SUCCESS: {
        return {
            ...state,
            loading: false,
            discipline: { ...action.payload.data },
        }
    }
    case CHALLENGES_LEADERBOARD_ERROR: {
        return {
            ...state,
            loading: false,
            errorMessage: action.payload.errorMessage,
        }
    }
    case CHALLENGES_NEXT_CHALLENGE_INFO_SUCCESS: {
        return {
            ...state,
            nextChallenge: { ...action.payload.data },
        }
    }
    case CHALLENGES_PROMO_SHOW: {
        return {
            ...state,
            promoOpened: true,
        }
    }
    case CHALLENGES_PROMO_HIDE: {
        return {
            ...state,
            promoOpened: false,
        }
    }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/challenges.js